<template lang="pug">
    ModelBasic(:show-left="showForm" :status="status" :downloadShow='false' :downloadResource = "false" :error-info="errorInfo" @download="toDownloadPdf" :rightTitle="$t('gzzoc.ocularEmergencyTriage')" :download="download")
        template(slot="left-title")
            .form-title(ref="title" @click="titClick" :class="titleClass")
        template(slot="left-content")
            .form-container
                el-form.form(ref="form", :model="model", v-if="model.parameters")
                    el-form-item(
                        v-for="(item, index) in model.parameters",
                        :rules="rules[item.name]",
                        :key="index",
                        :prop="'parameters.' + index + '.value'")
                        .name(v-if="item.name!=='event'&&item.name!=='symptoms'") {{item.display}}
                        GroupTitle(v-if="item.data_type === 'title'" :title="item.title" :tip="item.tip")
                        //input-radio  事件
                        el-radio-group.item(
                            v-model="item.value"
                            v-else-if="item.ques_type === 'single_choice' && item.show_type === 'select'&& item.name === 'event'")
                            .box(
                                v-for="(info, i) in item.options",
                                :key='i',
                                ) {{i+1}} . {{info.title}}
                                el-radio.gzzoc-radio.triage-radio(
                                    v-for="(ele, j) in info.options",
                                    :key='j',
                                    @change="childClick(info,ele)"
                                    :label="ele.value") 
                                    span.text {{ele.show_name}}
                        //input-radio 症状
                        div(v-else-if="item.ques_type === 'single_choice' && item.show_type === 'select'&& item.name === 'symptoms'")
                            .symptoms(
                                v-for="(info, i) in item.options",
                                :key='i',
                                ) {{i+1}} . {{info.display}}
                                el-radio-group.item(
                                    v-if="info.ques_type === 'single_choice'"
                                    v-model="info.value")
                                    el-radio.gzzoc-radio.symptoms-radio(
                                        v-for="(ele, j) in info.options",
                                        :key='j',
                                        :label="ele.value")
                                        span.text  {{ele.show_name}}
                                div(v-else-if="info.ques_type === 'title_choice'")
                                    .eyesPain(v-for="(child,k) in info.children" :key="k") {{child.display}}
                                        el-radio-group.item(
                                            v-model="child.value",)
                                            el-radio.gzzoc-radio(
                                                v-for="(ele, k) in child.options",
                                                :key='ele.value',
                                                @click.native.prevent.stop="cancelRadio($event,child,ele)"
                                                :label="ele.value") 
                                                span.text {{ele.show_name}}
                                el-checkbox-group.item(
                                    v-model="info.value",
                                    @change="fathChange($event,info)"
                                    v-else)
                                    el-checkbox.gzzoc-checkbox.symptoms-checkbox( 
                                        v-for="(ele, j) in info.options",
                                        :key='j', 
                                        :name="ele.show_name",
                                        :label="ele.value") 
                                        span.text {{ele.show_name}}
                                        //- @click.prevent="boxChange" //默认行为阻止        
                                        div(@click.prevent v-show="info.name!=='others'&&info.value.indexOf('视力下降')!==-1&&(ele.show_name==='视力下降'||ele.show_name==='Blurred vision')")
                                            .eyesDown(v-for="(child,k) in info.children" :key="k") {{child.display}}
                                                el-radio-group.item.text(
                                                    v-model="child.value",)
                                                    el-radio.gzzoc-radio( 
                                                        v-for="(ele, k) in child.options",
                                                        :key='ele.value',
                                                        @click.native.prevent="childChange($event,child,ele)"
                                                        :label="ele.value") {{ele.show_name}}
                                                        //- span(@click="childChange(ele,child)") {{ele.show_name}}
                       
                        //input-radio 
                        el-radio-group.item(
                            v-model="item.value",
                            @change="eyeSurgeries($event,item)"
                            v-else-if="item.ques_type === 'single_choice' && item.show_type === 'select'&& item.name !== 'event'")
                            el-radio.gzzoc-radio(
                                :class="(item.name === 'blurredVision'||item.name==='ocular_diseases')?'triage-radio':''"
                                v-for="(info, i) in item.options",
                                :key='i',
                                :label="info.value")
                                span.text(:class="(item.name ==='general_disease'?'perLine':'')")  {{info.show_name}}
                            div(v-show="item.value ==='1'&& item.name==='eye_surgeries'")
                                div(v-for="(ele,k) in item.select")
                                    el-select.gzzoc_select.item(
                                        v-model="ele.value",
                                        @change="surgeriesChange(ele)"
                                        :placeholder="ele.title"
                                        multiple)
                                        el-option(
                                            v-for="(info, i) in ele.options",
                                            :key='i',
                                            :label="info.lable",
                                            :value="info.value")
                                
                        //file
                        el-upload.gzzoc-upload.item(
                            v-model="item.value",
                            v-else-if="item.ques_type === 'file'",
                            action="/api/upl/s3/upload/big/file/unsafe",
                            :show-file-list="false",
                            :ref="item.name"
                            :before-upload="(file) => {return beforeImgUpload(file,item.name)}",
                            :on-success="(res,file,files) => {return uploadsucc(res,file,files,item.name)}",
                            :on-error="(res) => {return handleError(res, item.name)}",
                            :on-progress="() => {return handleProgress(item.name)}")
                            .file-content-wrapper
                                el-button.upload-button(type="primary" :loading="loadingUploadBtn(item.name)") {{$t('gzzoc.upload')}}
                                span.file-name(v-if="upload[item.name]") {{upload[item.name]}}
                        //select
                        el-select.gzzoc-select.item(
                            v-model="item.value",
                            v-else-if="item.ques_type === 'single_choice' && item.show_type === 'pull'")
                            el-option(
                                v-for="(info, i) in item.options",
                                :key='i',
                                :label="info.show_name",
                                :value="info.value")
                        //checkbox
                        el-checkbox-group.item(
                            v-model="item.value",
                            @change="eyeDisease($event,item)"
                            v-else-if="item.ques_type === 'multi_choice'")
                            el-checkbox.gzzoc-checkbox(
                                v-for="(info, i) in item.options",
                                :key='i',
                                :name="item.name"
                                :label="info.value") {{info.show_name}}
                        //completion
                        el-input.gzzoc-input.item(
                            type="text",
                            v-model="item.value",
                            v-else-if="item.ques_type === 'completion' && item.data_type === 'number'",
                            :placeholder="$t('gzzoc.numberPlease')")

                        //default
                        el-input.gzzoc-input(
                            type="text",
                            v-model="item.value",
                            v-else,
                            :placeholder="$t('gzzoc.contentPlease')")
        template(slot="left-footer")
            .form-footer
                el-button.gzzoc-button-primary.submit-btn(type="primary", @click="submit", :disabled="status === 'executing'") {{$t('startAnalysis')}}
                el-button.gzzoc-button-secondary.reset-btn(type="primary" @click="reset") {{$t('reset')}}
        template(slot="right-content")
            .right-content
                .main
                    .item(v-for="item in result.report")
                        .eye
                            img.eye-img(:src="imgsrc(item.image_id)")
                            .name {{item.img_res}}
                        .errResult(v-if="result.realReport.miss_flag")
                            .title {{result.realReport.remark}}
                .result.diagnose-advice(v-if="result.realReport")
                    .backInfo
                        div
                            li.title {{$t('gzzoc.AIimageAnalysisResults')}}：
                                //- .clsRes {{item.cls_res1}}
                            .title {{$t('gzzoc.triageGrade')}}：
                                span(:class="result.realReport.level===$t('gzzoc.Emergency')?'red':result.realReport.level===$t('gzzoc.SemiEmergency')?'warning':'normal'") {{result.realReport.level}}
                            .title {{$t('gzzoc.triageMessage')}}：
                                span(:class="result.realReport.level===$t('gzzoc.Emergency')?'red':result.realReport.level===$t('gzzoc.SemiEmergency')?'warning':'normal'") {{result.realReport.advice}}
                
</template>

<script>
import _ from 'lodash';
import { languages, i18n } from "@/locale";
import Logo from 'components/logo';
import UserNav from 'components/user-nav';
import ModelBasic from './gzzoc-model-basic';
import GroupTitle from '../components/group-title';
import UtilMixins from '@/mixins/utils';
import GzzocModelMixin from './gzzoc-model-mixin';
import ls from '@/utils/local-storage';
import { log } from 'three';

export default {
    data () {
        return {
            time:0,
            stopGetresult:false,
            languages: languages,
            loading: {
                executing: false,
            },
            lock: [],
            download: {
                loading: false,
                locked: false
            },
            modelData: {
                parameter_list: []
            },
            status: 'not_start',
            errorInfo: '',
            result: {
                value: '',
                explain: '',
                // success、error
                status: ''
            },
            upload: {
                loading_eyelid_images: false,
                status: "",
                eyelid_images: ""
            },
            date: "",
            model:{
               parameters:[]
            },
            withinArr:[],//一月内手术数组
            agoArr:[],//一月前手术数组
            showEyeSelect:false
        };
    },
    mixins: [UtilMixins, GzzocModelMixin],
    components: {
        Logo,
        UserNav,
        ModelBasic,
        GroupTitle
    },
    computed: {
        id () {
            return this.$route.params.id;
        },
        lang () {
            return _.find(languages, {lang: this.$i18n.locale}) || languages[0];
        },
        titleClass () {
            let cls = ls.get('lang');
            return {
                'cn': cls === 'zh-CN',
                'en': cls === 'en'
            };
        },
        showForm () {
            return _.get(this.model, 'parameters', []).length > 0;
        },
        rules () {
            return {
                name: [
                    {
                        required: true,
                        trigger: ['change','blur'],
                        message: i18n.t('message.checkInput')
                    }
                ],
                 age: [
                    {
                        trigger: ['blur', 'change'],
                        validator (rules, value, callback) {
                            if (value === undefined || value === '' || isFinite(+value)) {
                                callback();
                            }else {
                                callback(new Error('　'));
                            }
                        },
                        message: i18n.t('message.number')
                    },{
                        trigger: ['blur', 'change'],
                        validator (rules, value, callback) {
                            if(value<200){
                                callback();
                            }else {
                                callback(new Error('　'));
                            }
                        },
                        message: i18n.t('message.maxAge')
                    },
                    {
                        required: true,
                        trigger: ['change','blur'],
                        message: i18n.t('message.age')
                    }
                ],
            };
        }
    },
    mounted () {
        this.getData();
    },
    destroyed () {
        clearTimeout(this.timer)
    },
    methods: {
        fathChange(ev,children){
            
         },
         boxChange(e){
             console.log(e);
            //  e.target.autofocus = true
         },
         titClick(e){
             e.target.onfocus = true
         },
         cancelRadio(e,child,ele){
             //-  失去焦点  去掉默认外边样式
            let target1 = e.target.parentNode;
            let target2 = e.target.parentNode.parentNode;
            target1.blur();
            target2.blur();
            if(child.value===ele.value){
             this.$set(child, 'value', '');
            }else{
                this.$set(child, 'value', ele.value);
            }
         },
         eyeSurgeries(e,item){
             if(item.name === "eye_surgeries"){
                 if(e == 1){
                     this.showEyeSelect = true
                 }else{
                    this.withinArr = []
                    this.agoArr = []
                    item.select.map(ele=>ele.value=[])
                    this.showEyeSelect = false
                 }
             }
         },
         surgeriesChange(ele){
             if(ele.type==='within'){
                  this.withinArr = ele.value
             }else if(ele.type==='ago'){
                  this.agoArr = ele.value
             }
         },
         childChange(e,child,ele){
            //-  失去焦点  去掉默认外边样式
            let target1 = e.target.parentNode;
            let target2 = e.target.parentNode.parentNode;
            target1.blur();
            target2.blur();
            if(child.value===ele.value){
                return
            }else{
                this.$set(child, 'value', ele.value);
            }
            
         },
         stopClick(e){
             e.stopPropagation()
             e.preventDefault();
         },
        //  眼科疾病  无与其它互斥
         eyeDisease(e,item){
             if(e[0]==0&&e.length>1){
                 item.value.splice(e.indexOf(0),1)
             }else if(e.indexOf(0)!==-1){
                 item.value = [0]
             }
         },
        childClick(info,ele){
            //- console.log(this.model.parameters);
        },
        loadingUploadBtn (key) {
            return this.upload["loading_" + key];
        },
        reset () {
            this.stopGetresult = true
            _.forEach(_.get(this, 'model.parameters', []), ele => {
                switch (ele.ques_type) {
                    case "single_choice": {
                        // 症状重置
                        if(ele.name==='symptoms'){
                            ele.options.forEach(item=>{
                                this.$set(item, 'value', item.default_value);
                                if(item.children){
                                    item.children.forEach(child=>{
                                        this.$set(child, 'value', child.default_value);
                                    })
                                }
                            })
                        }else if(ele.name==='eye_surgeries'){//手术史重置
                            ele.select.forEach(child=>{
                                this.$set(child, 'value', []);
                            })
                            this.$set(ele, 'value', ele.default_value);
                        }else{
                            this.$set(ele, 'value', ele.default_value);
                        }
                        break;
                    }
                    case "multi_choice": {
                        this.$set(ele, 'value', ele.default_value);
                        break;
                    }
                    default: {
                        this.$set(ele, 'value', '');
                        break;
                    }
                }
                this.upload.eyelid_images = "";
            });
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        beforeImgUpload (file) {
            const types = ['image/jpeg', 'image/png', 'image/jpg'];
            const size = 5;

            const isJPG = (_.indexOf(types, file.type) > -1);
            const isLt2M = file.size / 1024 / 1024 < size;

            if (!isJPG) {
                this.$message.error(i18n.t('message.imgTypeUnknown'));
            } else if (!isLt2M) {
                this.$message.error(i18n.t('message.imgSizeExceed', { size }));
            }
            return isJPG && isLt2M;
        },
        uploadsucc (res, file, files, key) {
            const id = _.get(file, 'response.value[0]._id');
            const paramList = this.model.parameters;
            this.upload['loading_' + key] = false;
            if (id) {
                const i = _.findIndex(paramList, ['name', key]);
                paramList[i].value = [{
                    name:file.name,
                    value:id
                }];
                this.upload[key] = file.name;
                this.upload.status = 'success';
                this.$message.success(i18n.t('message.imgUploadSuccess'));

            } else {
                this.upload.status = 'error';
                this.$message.error(i18n.t('message.imgUploadFail'));
            }
        },
        handleProgress (key) {
            this.upload.status = 'progress';
            this.upload['loading_' + key] = true;
        },
        handleError (res, key) {
            const errorInfo = JSON.parse(res.toString().replace('Error: ', ''));
            const errorMessage = _.get(errorInfo, '_error.detail', '');

            if (errorMessage) {
                this.$message.error(errorMessage);
            }

            this.upload.status = 'error';
            this.upload['loading_' + key] = false;
        },
        getParameter () {
            let parameters = this.model.parameters;
            let value = {};
            for (let item of parameters) {
                if (item.data_type === 'title') {
                    continue;
                }
                let key = item.key_type;
                if (!value[key]) {
                    value[key] = [];
                }
                let val = item.value;
                if (item.data_type === 'number') {
                    val = Number.parseFloat(val);
                }
                if(item.key_type==='symptoms'){
                    let symptoms = []
                    item.options.forEach(ele=>{
                        if(ele.name==='blurredVision'){
                            // 视力相关
                            ele.options.forEach(val=>{
                                if(val.value==='视力下降'){
                                    let obj = {}
                                    if(ele.value.indexOf('视力下降')<0){
                                        // 未勾选  保持格式
                                        obj = {
                                               how_quickly:'',
                                               duration:'',
                                               degree:'',
                                           }
                                    }else{
                                        obj = {
                                            how_quickly:ele.children[0].value,
                                            duration:ele.children[1].value,
                                            degree:ele.children[2].value+'视力下降',
                                           }
                                    }
                                        symptoms.push({
                                           name:val.value,
                                           value:obj
                                       })
                                }else{
                                    symptoms.push({
                                        name:val.value,
                                        value:ele.value.indexOf(val.value)!==-1?1:0
                                    })
                                }
                            })
                        }else if(ele.name==='eye_pain'){
                            symptoms.push({
                                name:ele.subValue,
                                value:{
                                    pain_nature:ele.children[0].value,
                                    degree:ele.children[1].value,
                                }
                            })
                        }else{
                            symptoms.push({
                                name:ele.subValue==='发病时间'?'症状时间':ele.subValue,
                                value:ele.value
                            })
                        }
                    })
                     value.symptoms= symptoms
                }else if(item.key_type==='medical_history'){
                    if(item.name==='eye_surgeries'){//眼科手术
                         value[key].push({
                            name: item.subValue,
                            value: {
                               '一月内':item.select[0].value ,
                               '一月前':item.select[1].value 
                            }
                        });
                    }else if(item.name==="general_disease"){
                        val=val==='无'?[]:[val]
                         value[key].push({
                            name: item.subValue,
                            value: val 
                        });
                    }else{
                        value[key].push({
                            name: item.subValue,
                            value: val[0]===0?[]:val
                        });
                    }
                }else{
                    value[key].push({
                        name: item.subValue,
                        value: (val==='工业生产'||val==='生活意外')?'化学物质入眼':val
                    });
                }
            }
            return value;
        },
        submit () {
            this.$refs.form.validate(result => {
                if (!result) {
                    this.$message.error(this.$t('pleaseCheckInput'));
                    return;
                }else if(this.showEyeSelect&&!this.withinArr.length&&!this.agoArr.length){
                    this.$message.error(i18n.t('EyeSelect'));
                    return;
                }else if (this.upload.eyelid_images === "") {
                    this.$message.error(i18n.t('message.imgAtLeastOne'));
                    return;
                }
                this.status = 'executing';
                this.stopGetresult = false
                let parameters = this.getParameter();
                // 单独处理parameters.eye_imgs  图片参数
                parameters.eye_imgs[0] = parameters.eye_imgs[0].value[0]
                this.$http.post('mli/predict_model/create_task', {
                    model_id: this.id,
                    parameters
                }).then(resp => {
                    if (_.get(resp, 'body.value.code') !== 0) {
                        let errorInfo = _.get(resp, 'body.value.error');
                        this.status = 'failed';
                        this.$message.error(errorInfo);
                        this.errorInfo = errorInfo;
                        return;
                    }
                    this.task_id = _.get(resp, 'body.value.data.task_id');
                    if(!this.task_id.length){
                        let errorInfo = _.get(resp, 'body.value.error');
                        this.status = 'failed';
                        this.$message.error(errorInfo);
                        this.errorInfo = errorInfo;
                        return;
                    }else this.getResult(this.task_id);
                });
            });
        },
        async getData () {
            // 获取表单数据
            this.model.parameters = i18n.t('gzzoc_triage')
            this.reset();
        },
        getResult (taskId) {
            if (!taskId) {
                this.status = 'not_start';
                this.time = 0
                return;
            }
            clearTimeout(this.timer);
            this.$http.get('/api/mli/predict_model/task_result', {
                params: {
                    task_id: Array.isArray(taskId) ? taskId.join('|') : taskId
                }
            }).then(resp => {
                if (_.get(resp, 'body.value.code') !== 0) {
                    let errorInfo = _.get(resp, 'body.value.error');
                    this.status = 'failed';
                    this.$message.error(errorInfo);
                    this.errorInfo = errorInfo;
                    return;
                }
                const status = _.get(resp, 'body.value.data.status');
                if (status === 'failed') {
                    let errorInfo = _.get(resp, 'body.value.data.error_info[0]', this.$t('gzzoc.execFailed'));
                    this.status = 'failed';
                    this.$message.error(errorInfo);
                    this.errorInfo = errorInfo;
                    return;
                } else if (status === 'completed') {
                    this.time = 0
                    const result = _.get(resp, 'body.value.data.results', {});
                    this.result = result;
                    let rep = this.result.report
                    if(rep.length>1){
                        rep[0].levelGrade =  rep[0].level ===this.$t('gzzoc.Emergency')?0:rep[0].level===this.$t('gzzoc.SemiEmergency')?1:2
                        rep[1].levelGrade =  rep[1].level ===this.$t('gzzoc.Emergency')?0:rep[1].level===this.$t('gzzoc.SemiEmergency')?1:2
                        this.result.realReport = rep[0].levelGrade>=rep[1].levelGrade?rep[1]:rep[0]
                    }else{
                        this.result.realReport = rep[0]
                    }
                    this.status = 'success';
                    clearTimeout(this.timer)
                    this.time = 0
                    return
                }
                if(this.stopGetresult){
                    clearTimeout(this.timer)
                    this.time = 0
                    this.status = 'not_start'
                    return
                }
                this.timer = setTimeout(() => {
                    this.getResult(taskId);
                }, 3000);
            }).catch(err=>{
                if(err.status === 503){
                    clearTimeout(this.timer)
                    this.time = 0
                     let errorInfo = this.$t('gzzoc.execFailed');
                    this.status = 'failed';
                    this.$message.error(errorInfo);
                    this.errorInfo = errorInfo;
                    return;
                }
            });;
        },
        toDownloadPdf () {
            let taskId = Array.isArray(this.task_id) ? this.task_id.join('|') : this.task_id;
            this.downloadPdf(taskId, "dprint", this.date, this.download);
        }
    }
};
</script>
<style lang="sass" scoped>
    .form-title
        width: 100%
        height: 48px
        margin-top: 24px
        background-repeat: no-repeat
        &.cn
            background-image: url(~public/images/gzzoc/ocular-emergency-triage-cn.png)
        &.en
            background-image: url(~public/images/gzzoc/ocular-emergency-triage-en.png)

    .form-container
        padding: 20px
        overflow: auto
        flex: 1 1 auto
        width: 400px
        .perLine
            width: 280px
            word-break: keep-all
            display: inline-flex
            white-space: pre-line
        .symptoms
            color: #000
            .el-radio-group
                display: block !important
            .symptoms-radio
                margin-left: 20px
                margin-right: 0px
                line-height: 20px
                vertical-align: middle
                .text
                    width:280px
                    oword-break: break-word
                    white-space: pre-line
            .symptoms-checkbox
                margin-left: 20px
                margin-right: 0px
                line-height: 20px
                display: flex !important
                display: inline-block
                vertical-align: middle
                .text
                    width:270px
                    word-break: break-word
                    white-space: pre-line
            .eyesDown
                line-height: 2
                font-family: PingFangSC-Regular
                font-size: 14px
                color: #666
                margin: 5px 0 5px 20px
                .text
                    margin-left: 20px
            .eyesPain
                line-height: 2
                font-family: PingFangSC-Regular
                font-size: 14px
                color: #666
                margin: 5px 0 5px 20px
                display: inline-block
                vertical-align: middle
                .radio-item 
                    .el-radio__inner
                        background: #999 !important
                        border-color: #999 !important
                .radio-item 
                    .el-radio__label
                        color: #999
                .text
                    width:280px
                    display: inline-block
                    word-break: normal
                    white-space: pre-line
                    vertical-align: top
        .box
            color: #000
            font-size: 16px
            line-height: 46px
        .triage-radio
            display: flex !important
            margin-left: 20px
            margin-right: 0px
            line-height: 20px
            vertical-align: middle
            .text
              width:280px
              oword-break: break-word
              white-space: pre-line
            .name
                line-height: 1.4
                font-family: PingFangSC-Regular
                font-size: 14px
                color: #666
                margin-bottom: 10px
                white-space: nowrap
        .name
            line-height: 1.4
            font-family: PingFangSC-Regular
            font-size: 14px
            color: #666
            margin-bottom: 10px
            white-space: nowrap
        .file-content-wrapper
            display: flex
            align-items: center
            margin-top: 10px
            width: 100%
            .upload-button
                flex: 0 0
                margin-top: 0
            .file-name
                flex: 1 1
                margin-left: 16px
                font-size: 14px
                color: #999
                overflow: hidden
                text-overflow: ellipsis
                white-space: nowrap
                text-align: left
    .form-footer
        padding: 20px 20px
        text-align: center
        height: 90px
        .submit-btn
            width: 232px
            height: 40px
        .reset-btn
            width: 104px
            height: 40px
            margin-left: 16px

    .right-content
        .main
            display: flex
            .item
                flex: 1 1 !important
                .eye
                    width:300px
                    display:flex
                    justify-content: center
                    align-items: center
                    margin: 20px auto
                    .eye-img
                        width: 300px
                        height: 300px
                        text-align:center
                        background-color: #fff
                        object-fit: scale-down
                    .name
                        font-family: PingFangSC-Regular
                        font-size: 14px
                        color: #333
                        text-align: center
                        margin-top: 16px
                    .errResult
                        padding: 16px 0
                        font-size: 24px
                        color: #000
        .result
            padding: 16px 0
            display: flex
            width: 26%
            margin: 0 auto
            &:not(:last-child)
                border-bottom: 1px solid #999
            .backInfo
                border-top: 1px solid #ababdb
                div
                    width:360px
                    margin: 0 auto
                    .title
                        font-family: PingFangSC-Semibold
                        font-size: 20px
                        color: #333
                        line-height: 40px
                        list-style: disc
                        .red
                            color:#ed2727
                        .warning
                            color:#ebae26
                        .normal
                            color:#55c31d
                        .clsRes
                            font-size:32px
                            margin-left: 24px
                    .detail
                        .detail-item
                            line-height: 20px
                            vertical-align: top
                            margin-top: 8px
                            margin-right: 2%
                            .item-name
                                font-family: PingFangSC-Regular
                                font-size: 14px
                                color: #666
                            .item-result
                                font-family: PingFangSC-Regular
                                font-size: 14px
                                color: #333
        .footer
            .footer-item
                width: 230px
                position: relative
                left: 100%
                transform: translateX(-100%)
                &:not(:first-child)
                    margin-top: 8px
                .name
                    font-family: PingFangSC-Regular
                    font-size: 14px
                    color: #666
                    line-height: 20px
                    display: inline-block
                    height: 20px
                .value
                    font-family: PingFangSC-Regular
                    font-size: 14px
                    color: #333
                    line-height: 20px
                    display: inline-block
                    height: 20px
</style>
